import { useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import SocketIOContext from '../context/socketIOContext';

const baseStatisticType = statisticType =>
  String(statisticType || '').replace(/-v\d+$/, '');

const STATISTIC_ROUTE_BY_BASE = {
  demography: '/demographyStats',
  'booking-origin': '/bookingOriginStats',
  'self-service': '/selfServiceStats',
  'call-center': '/callCenterStats',
  voucher: '/voucherStatistics',
  'resource-voucher': '/voucherStatistics',
  'discount-code': '/discountCodeStatistics',
};

export const StatisticJobNotifications = () => {
  const socket = useContext(SocketIOContext);

  useEffect(() => {
    if (!socket || typeof socket.on !== 'function') return undefined;

    const onDone = job => {
      if (!job) return;
      try {
        window.dispatchEvent(
          new CustomEvent('statistic-job-done', { detail: job })
        );
      } catch (_err) {
        // ignore event bus errors
      }

      const route = STATISTIC_ROUTE_BY_BASE[baseStatisticType(job.statisticType)];
      toast.success('Deine Statistik ist fertig.', {
        toastId: `statistic-job-done-${job._id}`,
        onClick: () => {
          if (route && window.location.pathname !== route) {
            window.location.href = route;
          }
        },
        autoClose: 8000,
      });
    };

    const onFailed = job => {
      if (!job) return;
      try {
        window.dispatchEvent(
          new CustomEvent('statistic-job-failed', { detail: job })
        );
      } catch (_err) {
        // ignore event bus errors
      }

      const detail = job.errorMessage ? ` – ${job.errorMessage}` : '';
      toast.error(`Deine Statistik konnte nicht berechnet werden${detail}`, {
        toastId: `statistic-job-failed-${job._id}`,
        autoClose: 10000,
      });
    };

    const onQueued = job => {
      if (!job) return;
      try {
        window.dispatchEvent(
          new CustomEvent('statistic-job-queued', { detail: job })
        );
      } catch (_err) {
        // ignore event bus errors
      }
    };

    const onProgress = job => {
      if (!job) return;
      try {
        window.dispatchEvent(
          new CustomEvent('statistic-job-progress', { detail: job })
        );
      } catch (_err) {
        // ignore event bus errors
      }
    };

    const offDone = socket.on('statistic:job:done', onDone);
    const offFailed = socket.on('statistic:job:failed', onFailed);
    const offQueued = socket.on('statistic:job:queued', onQueued);
    const offProgress = socket.on('statistic:job:progress', onProgress);
    const offStarted = socket.on('statistic:job:started', onProgress);

    return () => {
      if (typeof offDone === 'function') offDone();
      if (typeof offFailed === 'function') offFailed();
      if (typeof offQueued === 'function') offQueued();
      if (typeof offProgress === 'function') offProgress();
      if (typeof offStarted === 'function') offStarted();
    };
  }, [socket]);

  return null;
};

export default StatisticJobNotifications;
